<template>
  <span class="text">{{ text }}</span>
</template>

<script>
export default {

  name: 'DataPlaceholder',
  props: {
    text: {
      type: String,
      default: 'No data'
    }
  }
}
</script>

<style lang="css" scoped>
  .text {
    color: grey;
  }
</style>
